import { useQuery } from "@tanstack/react-query";
import { fetchLocations } from "../../api/ocpi";
import { computeStats, type NetworkStats } from "../../utils/stats";

export interface NetworkStatsResult {
  stats: NetworkStats | null;
  isLoading: boolean;
  isFetching: boolean;
  error: Error | null;
  updatedAt: number;
  refetch: () => void;
}

/**
 * Fetches OCPI locations and derives summary stats. Optionally polls on a
 * fixed interval — pass 0 to disable.
 */
export function useNetworkStats(refreshSec: number): NetworkStatsResult {
  const q = useQuery({
    queryKey: ["ocpi", "locations"],
    queryFn: ({ signal }) => fetchLocations(signal),
    staleTime: 5 * 60 * 1000,
    refetchInterval: refreshSec > 0 ? refreshSec * 1000 : false,
    refetchIntervalInBackground: false,
  });

  return {
    stats: q.data ? computeStats(q.data) : null,
    isLoading: q.isLoading,
    isFetching: q.isFetching,
    error: (q.error as Error | null) ?? null,
    updatedAt: q.dataUpdatedAt,
    refetch: () => q.refetch(),
  };
}
